import styles from './MonitoringPage.module.scss';
import React, {FC, useEffect, useMemo, useRef, useState} from "react";
import {ITableProps, Table} from "../../components/table/Table";
import PageWrapper from "../../components/pageWrapper/PageWeapper";
import {ROUTES} from "../../app/Routes";
import moment from "moment";
import {getLocaleStorageItem, setLocaleStorageItem, tableCustomDateSort, truncate} from "../../helper/other";
import "moment/locale/ru";
import {getDetailedDocuments, MonitoringStatuses, setSortType, SortDirections} from "../../ducks/montitoring";
import {Box} from "@material-ui/core";
import {
    Autocomplete,
    Button,
    Checkbox,
    Icon,
    IconButton,
    InputAdornment,
    ListItemIcon,
    MenuItem,
    Select,
    Stack,
    TextField,
    ThemeProvider
} from "@mui/material";
import {themeSelect} from "../../muiThemes";
import {styled} from "@mui/styles";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import processing from "./processing.svg";
import processError from "../../processError.svg";
import twoDocOkStatus from "../../twoDocOkStatus.svg";
import twoDocsErrorStatus from "../../twoDocsErrorStatus.svg";
import waitingForPair from "../../waitingForPair.svg";
import processFinishOkStatus from "../../processFinishokStatus.svg";
import processFinishErrorStatus from "../../processFinishErrorStatus.svg";
import deletedDoc from "./deletedDoc.svg";
import CloseIcon from "@mui/icons-material/Close";
import 'rsuite/styles/index.less';
import "./calendarCSS.css";
import {defaultFilter, getMonitoringApiObj, IMonitoringFilter, IUpdateDocument} from "../../api/monitoringApi";
import {getStoreUtils} from "../../store/utils";
import {Column} from "material-table";
import {getSortType, setStorageSortType} from "../../selectors/monitoring";
import "react-datepicker/dist/react-datepicker.css";
import {DateRangePicker as RangeDatePicker} from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import calendarIcon from "./calendarIcon.svg";
import {useWindowDimensions} from "../../hooks/use-windows-dimenssions";
import { getUploadApiObj } from '../../api/uploadApi';
import plural from 'plural-ru';


export interface IRecognitionActTable {
    id: string;
    contrAgent: string;
    organisation: string;
    period: string;
    upload_date: string;
    comment: string;
    status: number,
    packageId: number,
    checkAction: JSX.Element;
    actionButton: JSX.Element;
}

export interface IFilterOption {
    value: number | null;
    label: string;
    icon: string;
    isHidden?: boolean;
}

export const FILTER_OPTIONS: IFilterOption[] = [
    {
        value: null,
        label: "Распознавание",
        icon: processing,
    },
    {
        value: 1,
        label: "Акт не распознан",
        icon: processError,
    },
    {
        value: 12,
        label: "Акты сопоставлены",
        icon: twoDocOkStatus,
    },
    {
        value: 13,
        label: "Обнаружены расхождения",
        icon: twoDocsErrorStatus,
    },
    {
        value: 11,
        label: "Ожидание ответного акта",
        icon: waitingForPair,
    },
    {
        value: 14,
        label: "Акт принят",
        icon: processFinishOkStatus,
    },
    {
        value: 15,
        label: "Акт отклонен",
        icon: processFinishErrorStatus,
    },
    {
        value: 8,
        label: "Удален",
        icon: deletedDoc,
    },
];

export interface IMonitoringPageStateProps {
    list: IRecognitionActTable[];
    isUploadPopupOpen: boolean;
    options: string[];
    sort: string;
    listPage: number;
    checkboxShow: boolean;
    docIds: string[];
}

export interface IMonitoringPageDispatchProps {
    getRecognitionActs: (filter?: IMonitoringFilter, isSearch?: boolean) => void;
    getDetailedDocuments: (docId: string) => void;
    getImagesForModalPreview: (docId: string) => void;
    routeTo: (route: string | null, id?: number) => void;
    updateDocumentStatus: (documentId: string, props: IUpdateDocument, helpForm?: boolean) => void;
    setSortType: (sort: SortDirections | undefined) => void;
    setSearchOptions: (options: string[]) => void;
    handleCreateDocsPair: (docIds: string[]) => void;
    setListPage: (pageNumber: number) => void;
    setCheckboxShow: (flag: boolean) => void;
    getActsForHandleRecognition: () => void;
    setPreviewModalOpen: (flag: boolean) => void;
    deleteUnrecognizedPackagesImages: (packageID: number) => void;
    popupPush: (popup: any) => void;
}

export interface IMonitoringPageState {
    dateFrom: string;
    dateTo: string;
    statusesFiltered: IFilterOption[];
    statuses: IFilterOption[];
    search: string;
    status: number;
    timeout: any;
    selectedRows: string[];
}

export type MonitoringPageProps = IMonitoringPageStateProps & IMonitoringPageDispatchProps;

let interval: NodeJS.Timeout | undefined = undefined;

const initialState: IMonitoringPageState = {
    dateFrom: moment().add(-1, "y").format('YYYY-MM-DD HH:mm:ss'),
    dateTo: moment().format("YYYY-MM-DD 23:59:59"),
    statuses: [...FILTER_OPTIONS],
    statusesFiltered: [...FILTER_OPTIONS.filter(elem => ![MonitoringStatuses.ACTS_PASSED, MonitoringStatuses.ACTS_REJECTED, MonitoringStatuses.DELETED].includes(elem.value as MonitoringStatuses))],
    search: "",
    status: 0,
    timeout: undefined,
    selectedRows: [],
}

const CustomSelect = styled(Select)(() => ({
    "&.MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "transparent"
        },
        "&:hover fieldset": {
            borderColor: "transparent"
        },
        "&.Mui-focused fieldset": {
            borderColor: "transparent"
        }
    }
}));

export const MonitoringPage: FC<MonitoringPageProps> = (props) => {
    let stateFromStorage: Partial<IMonitoringPageState> | undefined = undefined;
    const tableContainerRef = useRef<HTMLDivElement | null>(null);
    useWindowDimensions();
    try {
        stateFromStorage = JSON.parse(getLocaleStorageItem("stateFromStorage") || 'null');
    } catch (e) {
        console.log("Error parsing state from storage", e);
    }
    const [state, setState] = useState(stateFromStorage ? {
        ...stateFromStorage, dateFrom: moment().add(-1, "y").format("YYYY-MM-DD HH:mm:ss"),
        dateTo: moment(moment().format("YYYY-MM-DD 23:59:59")).format('YYYY-MM-DD HH:mm:ss'),
        selectedRows: []
    } : {...initialState});

    // Добавляем состояние для управления открытием меню
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const data = (props.sort === SortDirections.DESC || !props.sort) ? [...props.list].sort((a, b) => tableCustomDateSort(
        b.upload_date,
        a.upload_date,
        "DD.MM.YYYY HH:mm:ss",
    )) : [...props.list].sort((a, b) => tableCustomDateSort(
        a.upload_date,
        b.upload_date,
        "DD.MM.YYYY HH:mm:ss",
    ));

    // Проверяем, все ли фильтры выбраны
    const allFiltersSelected = state.statuses.every(status => status.isHidden);

    const {docIds, handleCreateDocsPair, checkboxShow} = props;

    const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const allIds = data.map(item => item.id);
            setState({...state, selectedRows: allIds});
        } else {
            setState({...state, selectedRows: []});
        }
    };

    const handleSelectRow = (event: React.ChangeEvent<HTMLInputElement>, id: string) => {
        event.stopPropagation();
        const selectedIndex = state.selectedRows.indexOf(id);
        let newSelected: string[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(state.selectedRows, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(state.selectedRows.slice(1));
        } else if (selectedIndex === state.selectedRows.length - 1) {
            newSelected = newSelected.concat(state.selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                state.selectedRows.slice(0, selectedIndex),
                state.selectedRows.slice(selectedIndex + 1),
            );
        }

        setState({...state, selectedRows: newSelected});
    };

    const updatedList = () => {
      props.getRecognitionActs({
        sort: defaultFilter.sort,
        sortBy: defaultFilter.sortBy,
        extendData: true,
        filter: {
          status: state.statusesFiltered.map(elem => elem.value),
          loadDateFrom: moment(state.dateFrom).toDate().toISOString(),
          loadDateTo: moment(state.dateTo).toDate().toISOString(),
          jsonContentText: state.search,
        }
      });

      setState(prev => ({
        ...prev,
        selectedRows: []
      }));
    }

    const handleMultipleSwap = async () => {
        const { selectedRows } = state;
    
        try {
            // Для каждой выбранной строки выполняем обмен документов
            const swapOperations = selectedRows.map(async (rowId) => {
                try {
                    // Получаем данные документа
                    const response = await getMonitoringApiObj().getDetailedDocumentByDocId(rowId);
                    const documentData = await response.json();

                    const mainId = documentData.docflowDocumentData.pairDocumentId
                    const docId = documentData.docId
                    
                    await getUploadApiObj().swapDocs(
                        mainId, 
                        docId
                    );
                    
                } catch (error) {
                    console.error(`Error swapping documents for row ${rowId}:`, error);
                }
            });
    
            // Выполняем все операции
           await Promise.all(swapOperations);
            
            // Обновляем список документов
            updatedList();
            
        } catch (error) {
            console.error("Error in handleMultipleSwap:", error);
        } finally {
            // Очищаем выбранные строки
            setState(prev => ({
                ...prev,
                selectedRows: []
            }));
        }
    };

    const handleDeleteSelected = async () => {
      const { selectedRows } = state;
      const filteresForDeletedStatus = props.list.filter((item) => item.status !== MonitoringStatuses.DELETED && selectedRows.includes(item.id))
      const count = filteresForDeletedStatus.length;
      const wordFormDoc = plural(count, 'документ', 'документа', 'документов');
      const wordFormDel = plural(count, 'удален', 'удалено', 'удалено');
      props.popupPush({
        actionTitle: "Да",
        actionVisible: true,
        cancelVisible: true,
        cancelTitle: "Отмена",
        data: [`Будет ${wordFormDel} ${count} ${wordFormDoc}.\n Вы действительно хотите продолжить ?`],
        actionHandler: async () => {
          // Создаем массив для хранения промисов удаления
          const deletePromises = filteresForDeletedStatus.map(async ({id}) => {
            try {
              // 1. Получаем детали документа
              const detailResponse = await getMonitoringApiObj()
                .getDetailedDocumentByDocId(id);
              const detailData = await detailResponse.json();

              // 2. Формируем запрос на удаление (ОБРАТИТЕ ВНИМАНИЕ: данные берутся из текущего документа!)
              const updatePayload = {
                docId: id,
                discrepancy: detailData.docflowDocumentData.extendData.discrepancyData,
                status: MonitoringStatuses.DELETED,
                comment: ''
              };

              // 3. Отправляем запрос на удаление ОДНОГО документа
              return getMonitoringApiObj().updateDocumentStatus([updatePayload]);
            } catch (error) {
              console.error(`Failed to delete document ${id}:`, error);
              throw error; // Пробрасываем ошибку для обработки выше
            }
          });

          try {
            await Promise.all(deletePromises);

            if(deletePromises.length === 0) return

            updatedList()

          } catch (error) {
            console.error("Error during batch delete:", error);
            // Здесь можно добавить обработку ошибок (например, показать уведомление)
          }
        },
      });
    };

    const handleUpdateCompareWatingDocs = async () => {
      const { selectedRows } = state;

      const filteredDocs = props.list.filter(
          item => item.status === MonitoringStatuses.WAITING_FOR_PAIR &&
                  selectedRows.includes(item.id)
      );

      if (filteredDocs.length === 0) return;

      try {
          // Получаем детали документов
          const detailsPromises = filteredDocs.map(async ({ id }) => {
              const response = await getMonitoringApiObj().getDetailedDocumentByDocId(id);
              return await response.json();
          });

          const documentsDetails = await Promise.all(detailsPromises);

          // Создаем пары
          const pairOperations = [];

          for (let i = 0; i < documentsDetails.length; i += 2) {
              if (i + 1 >= documentsDetails.length) break;
              // Фиксируем ID напрямую
              const docId1 = documentsDetails[i]?.docId;
              const docId2 = documentsDetails[i + 1]?.docId;

              // Проверяем наличие ID
              if (!docId1 || !docId2) {
                  console.error(`Missing ID for documents at position ${i} or ${i+1}`);
                  continue;
              }

              pairOperations.push(() =>
                  getMonitoringApiObj().handlePairDocuments(docId1, { docId: docId2 })
              );
          }

          if (pairOperations.length === 0) return;

          // Выполняем операции последовательно
          for (const operation of pairOperations) {
              try {
                  await operation();
              } catch (error) {
                  console.error("Error in pair operation:", error);
                  // Добавляем информацию о документах
                  const docIds = /documents:\s(.+)$/.exec(error.message)?.[1] || 'unknown';
                  console.error(`Failed to pair documents: ${docIds}`);
              }
          }

          // Обновляем список
          updatedList();
      } catch (error) {
          console.error("Error in compare operation:", error);
      }
  };
    const [isTwoWaitingForPairDocsInCheckedList, setIsTwoWaitingForPairDocsInCheckedList] = useState<IRecognitionActTable[]>([])

    useEffect(() => {
      const elementsWaitingForPair = props.list.filter((el) => {
        return state.selectedRows.includes(el.id) && el.status === MonitoringStatuses.WAITING_FOR_PAIR
      })

      setIsTwoWaitingForPairDocsInCheckedList(elementsWaitingForPair)

    }, [state.selectedRows])



    const defaultTableColumns = useMemo((): Column<Object>[] => {
        return [
            {
                title: <Checkbox
                    color={'warning'}
                    checked={state.selectedRows.length === data.length && data.length > 0}
                    indeterminate={state.selectedRows.length > 0 && state.selectedRows.length < data.length}
                    onChange={handleSelectAll}
                />,
                field: 'checkAction',
                sorting: false,
                render: rowData => {
                    const {id} = rowData as IRecognitionActTable;
                    return (
                        <Checkbox
                            color={'warning'}
                            checked={state.selectedRows.indexOf(id) !== -1}
                            onChange={(event) => handleSelectRow(event, id)}
                            onClick={(event) => event.stopPropagation()}
                        />
                    );
                }
            },
            {
                title: 'СТАТУС',
                field: 'status',
                sorting: false,
                render: rowData => {
                    const {status} = rowData as IRecognitionActTable;
                    const findStatus = FILTER_OPTIONS.find(elem => elem.value === status);
                    return <div
                        className={styles.iconRow} title={findStatus ? findStatus.label : ''}>
                        <ListItemIcon sx={{width: "35px", height: "35px"}}>
                            <Icon sx={{width: "35px", height: "35px"}}>
                                <img alt={""} src={findStatus ? findStatus.icon : twoDocsErrorStatus} width={35}
                                     height={35}/>
                            </Icon>
                        </ListItemIcon>
                    </div>;
                }
            },
            {
                title: 'ДАТА ЗАГРУЗКИ',
                field: 'upload_date',
                sorting: true,
                customSort: () => {
                    const item = getSortType();
                    if (interval) {
                        clearTimeout(interval)
                    }
                    interval = setTimeout(() => {
                        if (item === SortDirections.ASC) {
                            setStorageSortType(SortDirections.DESC)
                            getStoreUtils().dispatch(setSortType(SortDirections.DESC));
                        } else if (item === SortDirections.DESC || !item) {
                            setStorageSortType(SortDirections.ASC)
                            getStoreUtils().dispatch(setSortType(SortDirections.ASC));
                        }
                    }, 0)

                    return 1;
                }
            },
            {title: 'КОНТРАГЕНТ', sorting: false, field: 'contrAgent',},
            {title: 'ДОГОВОР', sorting: false, field: 'agreement',},
            {title: 'ОРГАНИЗАЦИЯ', sorting: false, field: 'organisation'},
            {title: 'ПЕРИОД', sorting: false, field: 'period',},
            {
                title: 'КОММЕНТАРИЙ', sorting: false, field: 'comment',
                render: rowData => {
                    const {comment} = rowData as IRecognitionActTable;
                    return <div
                        title={comment}
                    >
                        {truncate(comment, 40)}
                    </div>;
                }
            },
        ].filter(elem => elem) as Column<Object>[];
    }, [
        props.checkboxShow,
        docIds,
        state.selectedRows,
        data.length,
    ])

    const tableProps: ITableProps = {
        checkboxShow: props.checkboxShow,
        docIds: [],
        pageSize: 10,
        onChangeListPage: (pageNumber => {
            props.setListPage(pageNumber)
        }),
        initialPage: props.listPage,
        data: [...data],
        columns: defaultTableColumns,
        onRowClick: (event, rowData) => {
            if (!rowData) return;
            const row = rowData as IRecognitionActTable;
            const {id, packageId} = row;
            if (props.checkboxShow) {
                props.setPreviewModalOpen(true);
                props.getImagesForModalPreview(id);
            } else {
                if (![
                    MonitoringStatuses.DELETED,
                    MonitoringStatuses.RECOGNITION,
                ].includes(row.status)) {
                    if (row.status === MonitoringStatuses.ACTS_NOT_RECOGNISED) {
                        props.routeTo(`${ROUTES.Diff}/?packageId=${packageId}`);
                    } else {
                        props.routeTo(`${ROUTES.Diff}/${id}`);
                        getStoreUtils().dispatch(getDetailedDocuments(id))
                    }
                }
            }
        }
    }

    useEffect(() => {
        props.getRecognitionActs({
            sort: defaultFilter.sort,
            sortBy: defaultFilter.sortBy,
            extendData: true,
            filter: {
                status: state.statusesFiltered.map(elem => elem.value),
                loadDateFrom: moment(state.dateFrom).toDate().toISOString(),
                loadDateTo: moment(state.dateTo).toDate().toISOString(),
                jsonContentText: state.search,
            }
        });
    }, [])

    useEffect(() => {
        if (!props.isUploadPopupOpen) {
            props.getRecognitionActs({
                sort: defaultFilter.sort,
                sortBy: defaultFilter.sortBy,
                extendData: true,
                filter: {
                    status: state.statusesFiltered.map(elem => elem.value),
                    loadDateFrom: moment(state.dateFrom).toDate().toISOString(),
                    loadDateTo: moment(state.dateTo).toDate().toISOString(),
                    jsonContentText: state.search,
                }
            });
        }
    }, [state.statusesFiltered, state.dateTo, state.dateFrom, props.checkboxShow]);

    const options = [...new Set(props.options.filter(elem => elem)) as any].map((option, index) => ({
        label: option,
        key: `${index}1-option}`
    }))

    const mapStateToStorage = () => {
        let stateForStorage = {...state}
        delete stateForStorage.dateTo;
        delete stateForStorage.dateFrom;
        return stateForStorage;
    }

    return (
      <PageWrapper>
        <div className={styles.monitoringPageContainer}>
          <div className={styles.filtersContainer}>
            <div className={styles.topPart}>
              <div className={styles.leftPart}>
                <ThemeProvider theme={themeSelect}>
                  <div>
                    <Button
                      title="Связать два выбранные акта в пару и найти между ними расхождения"
                      className={styles.buttonAction}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        if (isTwoWaitingForPairDocsInCheckedList.length < 2) {
                          props.popupPush({
                            actionVisible: true,
                            actionTitle: "Хорошо",
                            data: [
                              `Сопоставить можно только два акта, находящихся в статусе "Ожидает ответного акта.\n Пожалуйста, отметьте галочками только два акта в нужном статусе.`,
                            ],
                          });
                          return;
                        }

                        handleUpdateCompareWatingDocs();
                      }}
                    >
                      {"Сопоставить"}
                    </Button>
                    <Button
                      color="error"
                      disabled={state.selectedRows.length === 0}
                      className={`${styles.buttonAction} ${
                        state.selectedRows.length === 0
                          ? styles.buttonActionDisabled
                          : styles.buttonActionDelete
                      }`}
                      title="Удалить выбранные документы"
                      onClick={() => {
                        if (state.selectedRows.length > 0) {
                          handleDeleteSelected();
                        } else {
                          props.setCheckboxShow(!props.checkboxShow);
                        }
                      }}
                    >
                      Удалить
                    </Button>
                    <Button
                      disabled={state.selectedRows.length === 0}
                      className={`${styles.buttonAction} ${
                        state.selectedRows.length === 0
                          ? styles.buttonActionDisabled
                          : ""
                      }`}
                      title="Поменять местами организацию и контрагента"
                      onClick={() => {
                        if (state.selectedRows.length > 0) {
                          handleMultipleSwap();
                        } else {
                          props.setCheckboxShow(!props.checkboxShow);
                        }
                      }}
                    >
                      Поменять местами
                    </Button>
                  </div>
                  <CustomSelect
                    className={styles.customSelect}
                    open={isMenuOpen}
                    onOpen={() => setIsMenuOpen(true)}
                    onClose={() => setIsMenuOpen(false)}
                    value={99999}
                    variant={"outlined"}
                    size={"small"}
                    sx={{
                      width: "90px",
                      border: "none",
                    }}
                    // Добавляем отображение "Все фильтры выбраны"
                    displayEmpty
                    renderValue={() => {
                      return allFiltersSelected
                        ? "Все фильтры выбраны"
                        : "Статус";
                    }}
                  >
                    {/* Заменяем скрытый MenuItem на динамическое сообщение */}
                    {allFiltersSelected ? (
                      <MenuItem disabled value={99999}>
                        <div className={styles.allFiltersSelected}>
                          Все фильтры выбраны
                        </div>
                      </MenuItem>
                    ) : (
                      <MenuItem style={{ display: "none" }} value={99999}>
                        Статус
                      </MenuItem>
                    )}

                    <div className={styles.statuses}>
                      {state.statuses.map(
                        (elem, index) =>
                          !elem.isHidden && (
                            <div
                              className={styles.menuItem}
                              key={elem.value + "-" + index}
                            >
                              <MenuItem value={elem.value as number}>
                                <div
                                  className={styles.filterElement}
                                  onClick={() => {
                                    // Закрываем меню при клике на элемент
                                    setIsMenuOpen(false);

                                    // Обновляем состояние фильтра
                                    const newStatuses = state.statuses.map(
                                      (item) =>
                                        item.value === elem.value
                                          ? { ...item, isHidden: true }
                                          : item
                                    );
                                    const newStatusesFiltered = [
                                      ...state.statusesFiltered,
                                      elem,
                                    ];

                                    setLocaleStorageItem(
                                      "stateFromStorage",
                                      {
                                        ...mapStateToStorage(),
                                        statuses: newStatuses,
                                        statusesFiltered: newStatusesFiltered,
                                      },
                                      10
                                    );

                                    setState((prevState) => ({
                                      ...prevState,
                                      statuses: newStatuses,
                                      statusesFiltered: newStatusesFiltered,
                                    }));
                                  }}
                                >
                                  <ListItemIcon
                                    sx={{ width: "40px", height: "40px" }}
                                    className={styles.listItemIcon}
                                  >
                                    <Icon
                                      sx={{ width: "40px", height: "40px" }}
                                    >
                                      <img
                                        alt={""}
                                        src={elem.icon}
                                        width={35}
                                        height={35}
                                      />
                                    </Icon>
                                  </ListItemIcon>
                                  <div>{elem.label}</div>
                                </div>
                              </MenuItem>
                            </div>
                          )
                      )}
                    </div>
                  </CustomSelect>
                </ThemeProvider>
              </div>
              <div className={styles.rightPart}>
                {checkboxShow && (
                  <div className={styles.description}>
                    Отметьте галочками два акта, которые хотите связать между
                    собой:
                  </div>
                )}
                {checkboxShow && (
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      handleCreateDocsPair(docIds);
                    }}
                    className={`${styles.buttonAction} ${
                      docIds.length < 2 ? styles.disabled : ""
                    }`}
                  >
                    Сопоставить
                  </Button>
                )}

                <Stack width={"500px"}>
                  <Autocomplete
                    sx={{
                      backgroundColor: "#FFF !important",
                    }}
                    limitTags={5}
                    autoComplete={false}
                    multiple={false}
                    onChange={(event, value) => {
                      setState({
                        ...state,
                        search:
                          typeof value === "string"
                            ? value
                            : value?.label || "",
                      });
                      setLocaleStorageItem(
                        "stateFromStorage",
                        {
                          ...mapStateToStorage(),
                          search:
                            typeof value === "string"
                              ? value
                              : value?.label || "",
                        },
                        10
                      );
                      props.getRecognitionActs(
                        {
                          sort: defaultFilter.sort,
                          sortBy: defaultFilter.sortBy,
                          extendData: true,
                          filter: {
                            status: state.statusesFiltered.map(
                              (elem) => elem.value
                            ),
                            loadDateFrom: moment(state.dateFrom)
                              .toDate()
                              .toISOString(),
                            loadDateTo: moment(state.dateTo)
                              .toDate()
                              .toISOString(),
                            jsonContentText:
                              typeof value === "string"
                                ? value
                                : value?.label || "",
                          },
                        },
                        true
                      );
                    }}
                    filterOptions={(options) => options}
                    inputValue={state.search}
                    onInputChange={(event, value) => {
                      if (state.timeout) {
                        clearTimeout(state.timeout);
                      }
                      const timeout = setTimeout(() => {
                        if (value === "" || (value && value.length >= 3)) {
                          props.getRecognitionActs(
                            {
                              sort: defaultFilter.sort,
                              sortBy: defaultFilter.sortBy,
                              extendData: true,
                              filter: {
                                status: state.statusesFiltered.map(
                                  (elem) => elem.value
                                ),
                                loadDateFrom: moment(state.dateFrom)
                                  .toDate()
                                  .toISOString(),
                                loadDateTo: moment(state.dateTo)
                                  .toDate()
                                  .toISOString(),
                                jsonContentText: value,
                              },
                            },
                            true
                          );
                        }
                      }, 600);
                      setState({
                        ...state,
                        search: value,
                        timeout: timeout,
                      });
                      setLocaleStorageItem(
                        "stateFromStorage",
                        {
                          ...mapStateToStorage(),
                          search: value,
                          timeout: timeout,
                        },
                        10
                      );
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.label === value.label
                    }
                    freeSolo={true}
                    size={"small"}
                    className={styles.filterItem}
                    disableClearable
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : `${option.label}`
                    }
                    options={options}
                    renderOption={(props, option) => (
                      <Box component={"li"} {...props} key={option.key}>
                        {option.label}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder={"Поиск по документам"}
                        InputProps={{
                          ...params.InputProps,
                          type: "search",
                          endAdornment: (
                            <InputAdornment position={"end"}>
                              <div className={styles.searchIcon} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </Stack>
              </div>
            </div>
            <div style={{ marginLeft: "20px" }} className={styles.bottomPart}>
              {state.statusesFiltered.map((elem) => (
                <div
                  title={elem.label}
                  className={styles.statusElement}
                  key={elem.value}
                >
                  <span> {truncate(elem.label, 10)}</span>
                  <IconButton
                    onClick={() => {
                      const value = elem.value;
                      const newStatusesFiltered = state.statusesFiltered.filter(
                        (item) => item.value !== value
                      );
                      const newStatuses = state.statuses.map((item) =>
                        item.value === value
                          ? { ...item, isHidden: false }
                          : item
                      );

                      setLocaleStorageItem(
                        "stateFromStorage",
                        {
                          ...mapStateToStorage(),
                          statusesFiltered: newStatusesFiltered,
                          statuses: newStatuses,
                        },
                        10
                      );

                      setState((prevState) => ({
                        ...prevState,
                        statusesFiltered: newStatusesFiltered,
                        statuses: newStatuses,
                      }));
                    }}
                    size={"small"}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                </div>
              ))}
            </div>
          </div>
          <div ref={tableContainerRef} className={styles.table}>
            <Table
              {...tableProps}
              bodyHeight={
                tableContainerRef.current
                  ? tableContainerRef.current.clientHeight
                  : 0
              }
            />
          </div>
        </div>
      </PageWrapper>
    );
}
